<template>
    <div
        class="card mb-5"
        :class="styles"
    >
        <div class="card-content">
            <div class="content">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        styles: {
            type: [Array, Object],
            required: false,
            default: () => [],
        },
    },
};
</script>
